export default __webpack_public_path__ + "static/media/PreviewOversized.edd9afc7.png";